/* UpgradeNudge — compact in-app upsell shown to free-tier users and visitors. */
import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { isPaidSubscriber } from '@/lib/subscription';

export default function UpgradeNudge() {
    const { user } = useAuth();
    if (isPaidSubscriber(user)) return null;
    return (
        <div className="mt-8 rounded-2xl bg-gradient-to-r from-lq-purple-500 to-lq-purple-700 text-white p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid="upgrade-nudge">
            <div className="flex items-start gap-3">
                <Sparkles size={20} className="mt-1 shrink-0 text-lq-peach-300"/>
                <div>
                    <p className="font-display text-lg font-semibold">Go unlimited &amp; advert-free</p>
                    <p className="text-sm opacity-90">Every puzzle, every language, up to 5 children &mdash; from &pound;3.49/month. 7-day free trial, pay by card or PayPal, cancel anytime.</p>
                </div>
            </div>
            <Link to="/pricing" className="shrink-0 inline-flex items-center justify-center bg-white text-lq-purple-700 hover:bg-lq-peach-100 font-semibold px-6 py-2.5 rounded-full transition-colors" data-testid="upgrade-nudge-cta">
                {user ? 'Upgrade now' : 'See plans'}
            </Link>
        </div>
    );
}
